/* ==========================================================================
   PRODUCTION AJAX QUICK ADD & CART CONTROLLER
   Universal delegated handler for 1-click cart addition across all homepage widgets
   ========================================================================== */

(function() {
  function updateCartCounters(count) {
    var cartCounters = document.querySelectorAll('[data-cart-count], .cart-bubble-count, .cart-count-bubble span');
    cartCounters.forEach(function(el) {
      el.textContent = count;
      el.classList.remove('visually-hidden');
    });
  }

  function openCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      var cartNotification = document.querySelector('cart-notification');
      if (cartNotification && typeof cartNotification.open === 'function') {
        cartNotification.open();
      }
    }
  }

  document.addEventListener('click', async function(e) {
    var btn = e.target.closest('[data-quick-add-variant]');
    if (!btn) return;

    e.preventDefault();
    var variantId = btn.getAttribute('data-quick-add-variant');
    if (!variantId) return;

    if (btn.classList.contains('is-loading') || btn.disabled) return;

    var originalHtml = btn.innerHTML;
    btn.classList.add('is-loading');
    btn.disabled = true;

    var textSpan = btn.querySelector('.btn-text');
    if (textSpan) {
      textSpan.textContent = 'Adding...';
    }

    try {
      var cartDrawer = document.querySelector('cart-drawer');
      var sectionsToFetch = cartDrawer ? 'cart-drawer,cart-icon-bubble' : '';

      var postBody = {
        id: parseInt(variantId, 10),
        quantity: 1
      };
      if (sectionsToFetch) {
        postBody.sections = sectionsToFetch;
        postBody.sections_url = window.location.pathname;
      }

      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript'
        },
        body: JSON.stringify(postBody)
      });

      if (!res.ok) {
        throw new Error('Failed to add to cart');
      }

      var parsedState = await res.json();

      var cartRes = await fetch('/cart.js');
      var cartData = await cartRes.json();

      updateCartCounters(cartData.item_count);

      btn.classList.remove('is-loading');
      btn.classList.add('is-success');
      
      if (textSpan) {
        textSpan.textContent = '✓ Added';
      }

      // If cart-drawer component exists and returned section HTML, update drawer contents
      if (cartDrawer && parsedState.sections && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsedState);
      } else {
        openCartDrawer();
      }

      // Trigger standard pubsub or cart drawer event
      if (window.pubsub && typeof window.pubsub.publish === 'function') {
        window.pubsub.publish('cart-update', { source: 'quick-add', cart: cartData });
      }
      document.dispatchEvent(new CustomEvent('ajax-cart:updated', { bubbles: true, detail: { cart: cartData } }));

      setTimeout(function() {
        btn.innerHTML = originalHtml;
        btn.classList.remove('is-success');
        btn.disabled = false;
      }, 2000);

    } catch (err) {
      console.error('AJAX Quick Add Error:', err);
      btn.classList.remove('is-loading');
      btn.classList.add('is-error');
      if (textSpan) {
        textSpan.textContent = 'Error';
      }

      setTimeout(function() {
        btn.innerHTML = originalHtml;
        btn.classList.remove('is-error');
        btn.disabled = false;
      }, 2500);
    }
  });
})();
